import jwtDecode from "jwt-decode";
export function decodeToken(token) {

    if (token) {
        return jwtDecode(token);
    }
    else {
        return null
    }
}